exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#level2Stage {\n  cursor: none !important; }\n\n.stones-htw {\n  position: absolute;\n  width: 20%;\n  height: 30%;\n  cursor: none !important; }\n", ""]);

